import { ListServiceTypeResponse } from "@fitness-force/models";

export const SERVICETYPE_STATE: ListServiceTypeResponse ={
    items: []
}